import axios from "axios";
const Report = async (params, reportNumber) => {
  const re = await axios
    .post(`https://api.sitimm.org/api/reports/show`, {
      reportNumber,
      params,
    })
    .then((res) => {
      return res;
    });
  return re;
};

export default Report;
